const EnumTicketType = {
  BUG: "BUG",
  REQUEST: "REQUEST",
  GENERAL: "GENERAL",
};

export default EnumTicketType;
